module.exports = __webpack_public_path__ + "img/2009-07_the-daily-beast.31fff60d.png";